import { NgModule } from "@angular/core";
import {
  mapToCanActivateChild,
  PreloadAllModules,
  RouterModule,
  Routes,
} from "@angular/router";

import { RoutingPath } from "@core/enums/routing-path";
import { AuthGuard } from "@core/guards/auth.guard";
import { SetPasswordFlow } from "@features/auth/set-password/set-password-flow";

const routes: Routes = [
  {
    path: RoutingPath.Login,
    loadChildren: (): any =>
      import("./views/login/login.module").then((m) => m.LoginModule),
  },

  ...[
    {
      flow: SetPasswordFlow.ConfirmEmail,
      paths: [
        "account/confirmEmail",
        "account/confirm-email",
        "set-password",
        "setpassword",
        "create-password",
      ],
    },
    {
      flow: SetPasswordFlow.ResetPassword,
      paths: [
        "account/ConfirmNewPassword",
        "account/confirm-new-password",
        RoutingPath.ResetPassword,
      ],
    },
  ].flatMap(({ flow, paths }) =>
    paths.map((path) => ({
      path,
      data: { flow },
      loadComponent: (): any =>
        import("./features/auth/set-password/set-password.component").then(
          (m) => m.SetPasswordComponent
        ),
    }))
  ),
  {
    path: "",
    loadChildren: (): any =>
      import("./views/wrapper.module").then((m) => m.WrapperModule),
    canActivateChild: mapToCanActivateChild([AuthGuard]),
  },
  {
    path: "**",
    redirectTo: RoutingPath.NotFound,
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
